/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Drawer,
  TextField,
  FormControl,
  MenuItem,
  Tooltip,
  Table,
  Select,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TableHead,
  Dialog,
  TableBody,
  TableRow,
  TableCell,
  Grid,
  IconButton,
} from "@material-ui/core";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import "tippy.js/themes/light.css";
import {
  ExpandMore as ExpandMoreIcon,
  AddCircle,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save,
  Info,
  Bookmarks,
  Restore,
  Comment,
  DoubleArrow,
} from "@material-ui/icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faExclamationTriangle,
  faForward,
  faRobot,
} from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrBefore);
import TextEditor from "components/TextEditor/TextEditor.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";

import { makeStyles } from "@material-ui/core/styles";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import {
  grayColor,
  warningColor,
} from "assets/jss/material-dashboard-pro-react.js";

import { useTranslation } from "react-i18next";
import AuthContext from "../../contexts/AuthProvider.js";
// import ExchangeRates from "views/Control Panel/ExchangeRates.js";
import { Chip } from "@material-ui/core";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { CheckCircle, RadioButtonUnchecked } from "@material-ui/icons";
import { client } from "../../services/axiosClient";
import { ThreeDots } from "react-loader-spinner";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { toast } from "react-toastify";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { generateInsight } from "../../services/aiApi";
import { Slide as ToastSlide } from "react-toastify";
import AiLoadingMessage from "../../components/AiLoadingMessage/AiLoadingMessage";

const appendTippyToBody = () => document.body;

const notify = (message, type = "info") =>
  toast(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "light",
    type,
    transition: ToastSlide,
  });

const INITIATIVES_MOCK = [
  {
    id: "101",
    branch: "Branch A",
    workfront: "Workfront X",
    initiative: "Iniciativa XPTO",
    approvalGates: [
      { gateName: "Gate 1", approved: true, approvers: ["Alice"] },
      { gateName: "Gate 2", approved: false, approvers: ["Bob", "Carol"] },
    ],
    lastOnePageUpdate: "2 days ago",
    lastImplementationPlanUpdate: "2 weeks ago",
    lastPlannedResultsUpdate: "1 month ago",
  },
  {
    id: "102",
    branch: "Branch B",
    workfront: "Workfront Y",
    initiative: "Iniciativa ABC",
    approvalGates: [
      { gateName: "Gate 1", approved: true, approvers: ["Dan", "Erin"] },
      { gateName: "Gate 2", approved: true, approvers: ["Frank"] },
    ],
    lastOnePageUpdate: "3 days ago",
    lastImplementationPlanUpdate: "4 days ago",
    lastPlannedResultsUpdate: "2 days ago",
  },
];

{
  /* Auxiliary function to map the status text to the color of the "lighthouse" */
}
function getStatusCircleColor(status) {
  switch (status) {
    case "Green":
      return "#4caf50"; // Green

    case "Yellow":
      return "#ffeb3b"; // Yellow

    case "Red":
      return "#f44336"; // Red

    default:
      return "#9e9e9e"; // gray for indefinite status
  }
}

// ------------------------------------------------------------------

function sortData(data, sortConfig) {
  if (!sortConfig.key) return data;
  const sorted = [...data].sort((a, b) => {
    const aValue = a[sortConfig.key]?.toString().toLowerCase() || "";
    const bValue = b[sortConfig.key]?.toString().toLowerCase() || "";
    if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1;
    return 0;
  });
  return sorted;
}

// -------------------------------------------------

export default function ControlPanel() {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color;
  const [isLoading, setIsLoading] = useState(false);
  const [isAiGenerating, setIsAiGenerating] = useState(false);

  // ------------------------------------------------------

  const ControlPanelStyles = (theme, clientColor) => ({
    ...customSelectStyle(theme, clientColor),
    ...customInputStyle(clientColor),

    root: {
      flexGrow: 2,
      padding: theme.spacing(2),
    },
    tabsRoot: {
      backgroundColor: grayColor[8],
      //BoxShadow: "0 2px 5px RGBA (0, 0, 0, 0.1)",
    },
    tabRoot: {
      fontSize: "1rem",
      fontWeight: 400,
      color: clientColor,
      textTransform: "none",
      "&:hover": {
        color: clientColor,
        opacity: 1,
      },
      "&.Mui-selected": {
        color: "black",
        fontWeight: 500,
        borderBottom: `2px solid ${clientColor}`,
      },
      "&:focus": {
        color: clientColor,
      },
    },
    indicator: {
      backgroundColor: clientColor,
      height: "1.5px",
    },
    cardIconTitle: {
      ...cardTitle,
      marginTop: "0px",
      marginBottom: "0px",
      padding: "10px",
    },
    timelineDotGray: {
      backgroundColor: theme.palette.grey[100],
    },
    addButton: {
      marginBottom: theme.spacing(2),
      height: "22px !important",
      width: "30px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
      margin: "10px 0 0 10px !important",
      padding: "0 !important",
    },
    cardButton: {
      padding: "0 !important",
      margin: "0 !important",
      height: "30px !important",
      width: "30px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
    },
    cardButtonIcon: {
      margin: "0 !important",
      position: "absolute !important",
      top: "50% !important",
      left: "50% !important",
      transform: "translate(-50%, -50%)",
      width: "18px !important",
      height: "18px !important",
    },
    drawer: {
      width: 400,
      padding: theme.spacing(3),
      position: "relative",
    },
    drawer_highlights: {
      width: 800,
      padding: theme.spacing(3),
      position: "relative",
    },
    formControl: {
      marginBottom: theme.spacing(2),
      minWidth: 120,
      width: "100%",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: theme.palette.grey[400],
        },
        "&:hover fieldset": {
          borderColor: clientColor,
        },
        "&.Mui-focused fieldset": {
          borderColor: clientColor,
        },
      },
      "& .MuiInputLabel-outlined": {
        color: theme.palette.grey[600],
        "&.Mui-focused": {
          color: theme.palette.grey[500],
        },
      },
      "& .MuiOutlinedInput-input::placeholder": {
        color: theme.palette.grey[600],
        opacity: 1,
      },
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    iconButtonCustom: {
      cursor: "pointer",
      "&:hover": {
        color: clientColor,
      },
    },
    actionIconsCustom: {
      display: "flex",
      gap: theme.spacing(1),
      justifyContent: "center",
      alignItems: "center",
    },
    center: {
      textAlign: "center",
    },
    tableHeadCell: {
      fontWeight: "bold",
      backgroundColor: "white",
      cursor: "pointer", // Indicates that the cell is clickable
    },
    sortIndicator: {
      marginLeft: theme.spacing(1),
      fontSize: "0.8rem",
    },
    filterContainer: {
      marginBottom: theme.spacing(2),
      display: "flex",
      alignItems: "center",
    },
    filterItem: {
      marginRight: theme.spacing(2),
      minWidth: 200,
    },
    accordionRootCustom: {
      marginBottom: theme.spacing(0.2),
      overflow: "hidden",
      boxShadow: "none", // Removes the shadow

      "&:before": {
        display: "none", // Removes the line before Accordion (if any)
      },
      // First Accordion

      "&:first-of-type": {
        borderRadius: "10px 10px 10px 10px",
      },
      // According to Accordion (specific case of the 'half')

      "&:nth-of-type(2)": {
        borderRadius: "10px 10px 10px 10px",
      },
      // Third (or last) Accordion

      "&:last-of-type": {
        borderRadius: "10px 10px 10px 10px",
      },
    },
    accordionRootHighlights: {
      marginBottom: theme.spacing(0.2),
      boxShadow: "none", // Removes the shadow

      overflow: "hidden",
      border: `1px solid ${theme.palette.grey[300]}`, // Adds light gray edge

      "&:before": {
        display: "none", // Removes the line before Accordion (if any)
      },
      // First Accordion

      "&:first-of-type": {
        borderRadius: "10px 10px 10px 10px",
      },
    },
    textFieldRoot: {
      "& .MuiInput-underline:before": {
        borderBottom: "1px solid #ccc", // Lower Border Standard Color
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottom: `2px solid ${clientColor}`, // Color when passing the mouse
      },
      "& .MuiInput-underline:after": {
        borderBottom: `2px solid ${clientColor}`, // Color when selected
      },
    },
    inputText: {
      color: "#666", // Standard text color

      "&:focus": {
        color: "#666", // Text color when selected
      },
    },
    labelText: {
      color: "#666", // LABEL STANDARD COLOR

      "&.Mui-focused": {
        color: "#666", // LABEL COLOR When focused
      },
    },
    timelineContent: {
      padding: theme.spacing(2),
    },
    reason: {
      fontWeight: "bold",
    },
    message: {
      marginTop: theme.spacing(1),
    },
    starIcon: {
      // Optional style for the star

      color: "gold",
    },
    sortIcon: {
      fontSize: "14px",
      marginLeft: "6px",
      color: "#ccc",
    },
    activeSortIcon: {
      color: "#aaa",
    },

    attention: {
      backgroundColor: warningColor[0] + " !important",
      animation: "$attention 3s ease infinite",
    },
    "@keyframes attention": {
      "10%": {
        transform: "scale(1.1)",
      },
      "13.33%,20%": {
        transform: "rotate(-10deg) scale(1.1)",
      },
      "16.67%": {
        transform: "rotate(10deg) scale(1.1)",
      },
      "23.33%": {
        transform: "rotate(0deg) scale(1.1)",
      },
      "33%": {
        transform: "scale(1)",
      },
    },

    actionDisabled: {
      opacity: "0.5 !important",
      pointerEvents: "none",
    },
    textEditorRoot: {
      // Set custom styles for the textDitor wrapper if necessary

      border: "1px solid #ccc",
      padding: theme.spacing(2),
      borderRadius: "4px",
    },
    customOutlined: {
      borderColor: clientColor + " !important",
    },
  });

  const client_styles = (theme) => ({
    ...ControlPanelStyles(theme, clientColor),
  });

  const useStyles = makeStyles(client_styles);

  const classes = useStyles();
  const { t } = useTranslation(); // To access the translation keys

  // ----------------------------------------------------------------
  // Main messages
  // ----------------------------------------------------------------

  const [sections, setSections] = useState([]);
  const [sortConfigSections, setSortConfigSections] = useState({
    key: null,
    direction: null,
  });
  const [messageDrawerOpen, setSectionDrawerOpen] = useState(false);
  const [editingSectionId, setEditingSectionId] = useState(null);
  const [newSection, setNewSection] = useState({
    section_name: "",
    start_date: "",
    end_date: new Date().toISOString().split("T")[0], // Format yyyy-mm-dd

    status: "",
    keyMessage: "",
    next_steps: "",
  });

  const handleSortSections = (key) => {
    let direction = "ascending";
    if (
      sortConfigSections.key === key &&
      sortConfigSections.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfigSections({ key, direction });
  };

  const handleOpenSectionDrawer = () => {
    setEditingSectionId(null);
    setNewSection({
      section_name: "",
      start_date: "",
      end_date: new Date().toISOString().split("T")[0], // Format yyyy-mm-dd

      status: "",
      keyMessage: "",
      updateDate: new Date().toISOString().split("T")[0], // Defines the current date
    });
    setPendingDecisions([]); // Limpa decisions temporárias
    setNewDecision({
      initiative_id: "",
      priority: "",
      decisionTitle: "",
      decisionDescription: "",
    });
    setIsProgramRelated(false);
    setSectionDrawerOpen(true);
  };

  const handleCloseSectionDrawer = () => {
    setSectionDrawerOpen(false);
  };

  const handleEditSection = (record) => {
    setEditingSectionId(record.id);
    setNewSection({ ...record });
    setSectionDrawerOpen(true);
  };

  const refreshSectionsAndDecisions = async () => {
    try {
      const response = await client.post(
        "/api/control-panel-sections-decisions/",
        {
          action: "list",
        }
      );

      if (response.status !== 200) {
        throw new Error("Failed to fetch sections/decisions");
      }

      const data = response.data;
      if (data.success) {
        setSections(data.sections || []);
        setDecisions(data.decisions || []);
      } else {
        console.error("API error:", data.error);
      }
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
  };

  const isInvalidDate =
    newSection.start_date &&
    newSection.end_date &&
    new Date(newSection.end_date) < new Date(newSection.start_date);

  const handleSaveSection = async () => {
    try {
      setIsLoading(true);
      let payload;
      let createdSectionId = null;
      
      if (editingSectionId) {
        // Atualizando Section
        payload = {
          action: "updateSection",
          id: editingSectionId,
          section_name: newSection.section_name,
          start_date: newSection.start_date,
          end_date: newSection.end_date,
          status: newSection.status,
          keyMessage: newSection.keyMessage,
          next_steps: newSection.next_steps,
        };
      } else {
        // Criando nova Section
        payload = {
          action: "createSection",
          section_name: newSection.section_name,
          start_date: newSection.start_date,
          end_date: newSection.end_date,
          status: newSection.status,
          keyMessage: newSection.keyMessage,
          next_steps: newSection.next_steps,
        };
      }
      
      console.log("Payload sendo enviada:", payload);
      
      // Chamada via axios, enviando payload corretamente
      const response = await client.post(
        "/api/control-panel-sections-decisions/",
        payload
      );

      const data = response.data;
      
      // Check for non-success status or unsuccessful response
      if (response.status !== 200 && response.status !== 201) {
        const errorMsg = data?.error || data?.message || `HTTP ${response.status}`;
        throw new Error(
          `${editingSectionId ? "Failed to update section" : "Failed to create section"}: ${errorMsg}`
        );
      }
      
      console.log("Response data:", data); // Debug log

      if (data.success) {
        // Se foi uma criação, obtém o ID da section criada
        if (!editingSectionId && data.section && data.section.id) {
          createdSectionId = data.section.id;
          console.log("Section created with ID:", createdSectionId); // Debug log
          notify(t("control_panel.sections.created_success", "Section criada com sucesso!"), "success");
        } else if (editingSectionId) {
          notify(t("control_panel.sections.updated_success", "Section atualizada com sucesso!"), "success");
        }

        // Se existem pending decisions (modo criação), cria todas elas agora
        if (createdSectionId && pendingDecisions.length > 0) {
          console.log(`Creating ${pendingDecisions.length} pending decisions...`); // Debug log
          
          let successCount = 0;
          let errorCount = 0;
          
          for (const pendingDec of pendingDecisions) {
            try {
              const decisionPayload = {
                action: "createDecision",
                section_id: createdSectionId,
                initiative_id: pendingDec.initiative_id || "",
                is_program_related: pendingDec.is_program_related || false,
                priority: pendingDec.priority,
                decisionTitle: pendingDec.decisionTitle,
                decisionDescription: pendingDec.decisionDescription,
                done: false,
              };

              console.log("Creating decision with payload:", decisionPayload); // Debug log

              const decResponse = await client.post(
                "/api/control-panel-sections-decisions/",
                decisionPayload
              );

              console.log("Decision response status:", decResponse.status);
              console.log("Decision response data:", decResponse.data);

              // Check for success: status 200/201 and either success=true or no error
              if (
                (decResponse.status === 200 || decResponse.status === 201) && 
                (decResponse.data.success === true || (decResponse.data.success === undefined && !decResponse.data.error))
              ) {
                console.log("Decision created successfully:", decResponse.data);
                successCount++;
              } else {
                console.error("Failed to create decision:", decResponse.data?.error);
                errorCount++;
                notify(
                  t("control_panel.decisions.create_error", "Erro ao criar decisão") + ": " + (decResponse.data?.error || "Erro desconhecido"), 
                  "warning"
                );
              }
            } catch (decError) {
              console.error("Error creating pending decision:", decError);
              console.error("Decision error details:", decError.response?.data);
              errorCount++;
              notify(
                t("control_panel.decisions.create_error", "Erro ao criar decisão") + ": " + (decError.response?.data?.error || decError.message), 
                "warning"
              );
            }
          }
          
          // Show error message only if there were failures
          if (errorCount > 0) {
            notify(
              t("control_panel.decisions.some_errors", `Erro ao salvar ${errorCount} decisão(ões)`), 
              "warning"
            );
          }
        }

        // Recarrega a lista
        await refreshSectionsAndDecisions();
      } else {
        console.error("API error:", data.error);
        notify(
          t("control_panel.sections.save_error", "Erro ao salvar section") + ": " + (data.error || "Erro desconhecido"), 
          "error"
        );
      }
    } catch (error) {
      console.error("Error saving section:", error);
      console.error("Error response:", error.response); // Full response object
      console.error("Error response data:", error.response?.data); // Response data
      console.error("Error response status:", error.response?.status); // Response status
      
      // Try to extract meaningful error message
      let errorMessage = "Erro desconhecido";
      
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.data?.error) {
          errorMessage = error.response.data.error;
        } else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data.substring(0, 100); // Limit string length
        } else {
          errorMessage = `Erro HTTP ${error.response.status}`;
        }
      } else if (error.request) {
        // The request was made but no response was received
        errorMessage = "Sem resposta do servidor";
      } else {
        // Something happened in setting up the request
        errorMessage = error.message;
      }
      
      notify(
        t("control_panel.sections.save_error", "Erro ao salvar section") + ": " + errorMessage, 
        "error"
      );
    } finally {
      setIsLoading(false);
    }

    // Fecha drawer, reseta states
    handleCloseSectionDrawer();
    setPendingDecisions([]);
    setHasUnsavedSectionChanges(false);
    localStorage.removeItem("newSectionDraft");
  };

  const handleGenerateKeyMessage = async () => {
    try {
      setIsAiGenerating(true);
      
      const response = await generateInsight("key_message_generation");
      
      if (response.success) {
        // Atualiza o campo keyMessage com o conteúdo gerado pela AI
        setNewSection({
          ...newSection,
          keyMessage: response.text
        });
        
        // Marca como tendo alterações não salvas se estiver editando
        if (editingSectionId !== null) {
          setHasUnsavedSectionChanges(true);
        }
        
        // Notifica sucesso
        notify("Key messages geradas com sucesso pela IA!", "success");
      } else {
        // Se houver erro, mostra a mensagem de erro
        notify(response.text || "Erro ao gerar key messages", "error");
      }
    } catch (error) {
      console.error("Error generating key message:", error);
      notify("Erro ao conectar com o serviço de IA", "error");
    } finally {
      setIsAiGenerating(false);
    }
  };

  // EXAMPLE OF INITIAL STATE TO 3 WEEKS BECOME

  function threeMonthsAgo() {
    return dayjs().subtract(3, "month").format("YYYY-MM-DD");
  }
  
  function threeWeeksAgo() {
    return dayjs().subtract(3, "week").format("YYYY-MM-DD");
  }
  
  function today() {
    return dayjs().format("YYYY-MM-DD");
  }

  const [filterStart, setFilterStart] = useState(threeMonthsAgo);
  const [filterEnd, setFilterEnd] = useState(today);

  // ----------------------------------------------------------------
  // FILTER FOR SECTIONS
  // ----------------------------------------------------------------

  const [sectionFilter, setSectionFilter] = useState("");

  const uniqueSections = [
    ...new Set(sections.map((i) => i.section_name)),
  ].filter(Boolean);

  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);

  const filteredAndSortedSections = sortData(
    sections.filter((section) => {
      // Section name filter:

      const matchesSectionName = sectionFilter
        ? section.section_name === sectionFilter
        : true;

      // Date Filter (guarantee that section.start_date and section.end_date are valid):

      const sDate = dayjs(section.start_date || "");
      const eDate = dayjs(section.end_date || "");
      const startFilter = dayjs(filterStart);
      const endFilter = dayjs(filterEnd);

      // If the final date of a section is not before the initial filter
      // And if the start date of a section is not after the final filter, it is in the break.

      const isInDateRange =
        (!filterStart || eDate.isSameOrAfter(startFilter)) &&
        (!filterEnd || sDate.isSameOrBefore(endFilter));

      return matchesSectionName && isInDateRange;
    }),
    sortConfigSections
  );

  // ---NEW: Load new section draft from localStorage when drawer opens in NEW mode ---

  useEffect(() => {
    if (messageDrawerOpen && editingSectionId === null) {
      const storedDraft = localStorage.getItem("newSectionDraft");
      if (storedDraft) {
        setNewSection(JSON.parse(storedDraft));
      }
    }
  }, [messageDrawerOpen, editingSectionId]);

  useEffect(() => {
    if (messageDrawerOpen && editingSectionId === null) {
      localStorage.setItem("newSectionDraft", JSON.stringify(newSection));
    }
  }, [messageDrawerOpen, editingSectionId, newSection]);

  // ----------------------------------------------------------------
  // Initiatives
  // ----------------------------------------------------------------

  const [initiatives, setInitiatives] = useState([]);
  const [sortConfigInitiatives, setSortConfigInitiatives] = useState({
    key: null,
    direction: null,
  });
  const [isProgramRelated, setIsProgramRelated] = useState(false);

  useEffect(() => {
    async function loadInitiatives() {
      try {
        const response = await client.get("/api/decision-initiatives-list/");
        if (response.status === 200 && response.data.success) {
          setInitiatives(response.data.initiatives);
        }
      } catch (error) {
        console.error("Error loading initiatives: ", error);
      }
    }
    loadInitiatives();
  }, []);

  // eslint-disable-next-line no-unused-vars
  const handleSortInitiatives = (key) => {
    let direction = "ascending";
    if (
      sortConfigInitiatives.key === key &&
      sortConfigInitiatives.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfigInitiatives({ key, direction });
  };

  // =====================
  // UNSAVED CHANGES DIALOG
  // =====================

  const [unsavedDialogOpen, setUnsavedDialogOpen] = useState(false);
  const [onDiscardConfirm, setOnDiscardConfirm] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [onDiscardCancel, setOnDiscardCancel] = useState(null);

  // Tracks if the user has unsaved changes in the "Sections" drawer:

  const [hasUnsavedSectionChanges, setHasUnsavedSectionChanges] =
    useState(false);

  // ----------------------------------------------------------------
  // Filters for initiatives
  // ----------------------------------------------------------------
  // eslint-disable-next-line no-unused-vars
  const [branchFilter, setBranchFilter] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [workfrontFilter, setWorkfrontFilter] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [initiativeFilter, setInitiativeFilter] = useState("");
  // eslint-disable-next-line no-unused-vars
  const uniqueBranches = [...new Set(initiatives.map((i) => i.branch))].filter(
    Boolean
  );
  // eslint-disable-next-line no-unused-vars
  const uniqueWorkfronts = [
    ...new Set(initiatives.map((i) => i.workfront)),
  ].filter(Boolean);

  // ------------------STATE FOR DECISIONS NEEDED ------------------

  const [decisions, setDecisions] = useState([]);
  const [pendingDecisions, setPendingDecisions] = useState([]); // Decisions temporárias para novas sections

  const [editingDecisionId, setEditingDecisionId] = useState(null);
  const [newDecision, setNewDecision] = useState({
    initiative_id: "",
    priority: "",
    decisionTitle: "",
    decisionDescription: "",
  });

  const handleDecisionToggle = async (decisionId, checked) => {
    try {
      const payload = {
        action: "updateDecision",
        id: decisionId,
        done: checked,
      };
      const response = await client.post(
        "/api/control-panel-sections-decisions/",
        payload
      );

      if (response.status !== 200) {
        throw new Error("Failed to update 'done' status");
      }

      const data = response.data;
      if (data.success) {
        await refreshSectionsAndDecisions();
      } else {
        console.error("API error:", data.error);
      }
    } catch (error) {
      console.error("Error toggling decision:", error);
    }
  };

  // ------------------PRIORITY CIRCLE COLOR ------------------

  function getPriorityChip(priority) {
    switch (priority) {
      case "High":
        return (
          <Chip
            label={t("control_panel.decisions.priority.high")}
            style={{
              backgroundColor: "#f44336", // Red

              color: "#fff",
              fontWeight: "bold",
            }}
            size="small"
          />
        );
      case "Medium":
        return (
          <Chip
            label={t("control_panel.decisions.priority.medium")}
            style={{
              backgroundColor: "#ffeb3b", // Yellow

              color: "#333",
              fontWeight: "bold",
            }}
            size="small"
          />
        );
      case "Low":
        return (
          <Chip
            label={t("control_panel.decisions.priority.low")}
            style={{
              backgroundColor: "#4caf50", // Green

              color: "#fff",
              fontWeight: "bold",
            }}
            size="small"
          />
        );
      default:
        return (
          <Chip
            label={t("control_panel.decisions.priority.undefined")}
            style={{
              backgroundColor: "#9e9e9e", // Gray

              color: "#fff",
            }}
            size="small"
          />
        );
    }
  }

  // APIs

  useEffect(() => {
    async function loadSectionsAndDecisions() {
      try {
        setIsLoading(true);
        // Solicita { action: "list" }
        const response = await client.post(
          "/api/control-panel-sections-decisions/",
          { action: "list" }
        );

        if (response.status !== 200) {
          throw new Error("Failed to fetch sections/decisions");
        }

        // Em axios, dados = response.data
        const data = response.data;
        if (data.success) {
          setSections(data.sections || []);
          setDecisions(data.decisions || []);
        } else {
          console.error("API returned an error: ", data.error);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false); // encerra spinner
      }
    }

    loadSectionsAndDecisions();
  }, []);

  // NOVAS VARIÁVEIS DE ESTADO PARA O DELETE DIALOG
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({
    type: "",
    id: null,
    name: "",
  });

  // FUNÇÃO PARA ABRIR O DIÁLOGO DE DELETE
  const handleOpenDeleteDialog = (target) => {
    setDeleteTarget(target);
    setDeleteDialogOpen(true);
  };

  // FUNÇÃO PARA FECHAR O DIÁLOGO DE DELETE
  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteTarget({ type: "", id: null, name: "" });
  };

  // FUNÇÃO PARA CONFIRMAR A EXCLUSÃO
  const handleConfirmDelete = async () => {
    if (deleteTarget.type === "section") {
      // Exclusão de section via axios
      try {
        const payload = {
          action: "deleteSection",
          id: deleteTarget.id,
        };
        const response = await client.post(
          "/api/control-panel-sections-decisions/",
          payload
        );
        if (response.status !== 200) {
          throw new Error("Failed to delete section");
        }
        const data = response.data;
        if (data.success) {
          await refreshSectionsAndDecisions();
        } else {
          console.error("API error:", data.error);
        }
      } catch (error) {
        console.error("Error deleting section:", error);
      }
    } else if (deleteTarget.type === "decision") {
      // Exclusão de decision via fetch
      try {
        const payload = {
          action: "deleteDecision",
          id: deleteTarget.id,
        };
        const response = await client.post(
          "/api/control-panel-sections-decisions/",
          payload
        );
        if (response.status !== 200) {
          throw new Error("Failed to delete decision");
        }
        const data = response.data;
        if (data.success) {
          await refreshSectionsAndDecisions();
        } else {
          console.error("API error:", data.error);
        }
      } catch (error) {
        console.error("Error deleting decision:", error);
      }
    }
    setDeleteDialogOpen(false);
  };

  return (
    <div style={{ margin: "10px" }}>
      {/* Accordion 1 -Sections */}
      <Accordion className={classes.accordionRootCustom} defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <CardHeader
            color="client"
            icon
            style={{ marginTop: "10px", display: "flex", alignItems: "center" }}
          >
            <CardIcon color="client">
              <Bookmarks />
            </CardIcon>
            <h4
              className={classes.cardIconTitle}
              style={{ marginBottom: 0, whiteSpace: "nowrap" }}
            >
              {/* T("control panel.sections.title") */}
              {t("control_panel.sections.title")}
            </h4>
          </CardHeader>
        </AccordionSummary>
        <AccordionDetails style={{ display: "block" }}>
          <GridContainer
            justifyContent="space-between"
            alignItems="center" // Central vertical alignment
          >
            <GridItem className={classes.filterItem} xs={12} sm={8}>
              <Box display="flex" alignItems="center">
                {/* Filter icon */}
                <FontAwesomeIcon
                  icon={faFilter}
                  style={{
                    marginRight: "8px",
                    fontSize: "20px",
                    color: "#666",
                  }}
                />
                {/* Sections Filter (SELECT) */}
                <FormControl
                  size="medium"
                  className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                  style={{ paddingTop: "5.2px" }}
                >
                  <Select
                    displayEmpty
                    value={sectionFilter}
                    onChange={(e) => setSectionFilter(e.target.value)}
                    classes={{
                      select: `${classes.select} ${classes.selectFormControlOverride}`,
                    }}
                  >
                    <MenuItem value="">
                      {t("control_panel.initiatives.filters.all_sections")}
                    </MenuItem>
                    {uniqueSections.map((section_name) => (
                      <MenuItem key={section_name} value={section_name}>
                        {section_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box mx={1} />
                {/* Initial date filter */}
                <Tooltip
                  title={t(
                    "control_panel.initiatives.filters.tooltip_start_date"
                  )}
                  arrow
                >
                  <TextField
                    type="date"
                    value={filterStart}
                    onChange={(e) => setFilterStart(e.target.value)}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{
                      classes: { root: classes.labelText },
                      shrink: true,
                    }}
                  />
                </Tooltip>
                <Box mx={0.3} />
                <DoubleArrow style={{ color: "#666" }} />
                <Box mx={0.3} />
                {/* Final Date Filter */}
                <Tooltip
                  title={t(
                    "control_panel.initiatives.filters.tooltip_end_date"
                  )}
                  arrow
                >
                  <TextField
                    type="date"
                    value={filterEnd}
                    onChange={(e) => setFilterEnd(e.target.value)}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{
                      classes: { root: classes.labelText },
                      shrink: true,
                    }}
                  />
                </Tooltip>
                <Box mx={1} />
                {/* Reset dates with text */}
                <Tooltip
                  title={t(
                    "control_panel.initiatives.filters.tooltip_refresh_button"
                  )}
                  arrow
                >
                  <Button
                    color="client"
                    size="medium"
                    variant="outlined"
                    onClick={() => {
                      // Function to reset the dates for the last 3 weeks

                      setFilterStart(threeWeeksAgo());
                      setFilterEnd(today());
                    }}
                    className={classes.cardButton}
                  >
                    {" "}
                    <Restore className={classes.cardButtonIcon} />
                  </Button>
                </Tooltip>
              </Box>
            </GridItem>

            {/* Right -aligned Key Message button */}
            <GridItem>
              <Box display="flex" justifyContent="flex-end" alignItems="center">
                <Button
                  color="client"
                  className={classes.cardButton}
                  onClick={handleOpenSectionDrawer}
                  size="sm"
                  style={{ display: "flex", alignItems: "center" }} // Ensures that the icon and text are aligned
                >
                  <AddCircle className={classes.cardButtonIcon} />
                </Button>
              </Box>
            </GridItem>
          </GridContainer>

          <Table
            style={{
              tableLayout: "fixed",
              width: "100%",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableHeadCell}
                  onClick={() => handleSortSections("section_name")}
                  style={{ cursor: "pointer" }}
                >
                  <div className={classes.tableHeaderIcon}>
                    {t("control_panel.sections.table.headers.section_name")}
                    <FontAwesomeIcon
                      icon={
                        sortConfigSections.key === "section_name"
                          ? sortConfigSections.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfigSections.key === "section_name"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  onClick={() => handleSortSections("start_date")}
                  style={{ cursor: "pointer" }}
                >
                  <div className={classes.tableHeaderIcon}>
                    {t("control_panel.sections.table.headers.start_date")}
                    <FontAwesomeIcon
                      icon={
                        sortConfigSections.key === "start_date"
                          ? sortConfigSections.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfigSections.key === "start_date"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  onClick={() => handleSortSections("end_date")}
                  style={{ cursor: "pointer" }}
                >
                  <div className={classes.tableHeaderIcon}>
                    {t("control_panel.sections.table.headers.end_date")}
                    <FontAwesomeIcon
                      icon={
                        sortConfigSections.key === "end_date"
                          ? sortConfigSections.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfigSections.key === "end_date"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>
                <TableCell
                  className={classes.tableHeadCell}
                  onClick={() => handleSortSections("status")}
                  style={{ cursor: "pointer" }}
                >
                  <div className={classes.tableHeaderIcon}>
                    {t("control_panel.sections.table.headers.status")}
                    <FontAwesomeIcon
                      icon={
                        sortConfigSections.key === "status"
                          ? sortConfigSections.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfigSections.key === "status"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>
                <TableCell className={classes.tableHeadCell}>
                  {t("control_panel.sections.table.headers.key_message")}
                </TableCell>

                {/* NEW COLUMN FOR NEXT STEPS (SWAPPED) */}
                {userDetails?.has_next_steps && (
                  <TableCell className={classes.tableHeadCell}>
                    {t("control_panel.sections.table.headers.next_steps")}
                  </TableCell>
                )}

                {/* NEW COLUMN FOR DECISIONS NEEDED (SWAPPED) */}
                {userDetails?.has_decisions_needed && (
                  <TableCell className={classes.tableHeadCell}>
                    {t("control_panel.sections.table.headers.decisions_needed")}
                  </TableCell>
                )}

                <TableCell
                  className={`${classes.tableCell} ${classes.actionColumn}`}
                  align="center"
                >
                  {t("control_panel.sections.table.headers.actions")}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell
                    colSpan={8} // We keep colSpan = 8 because we have 8 columns in total now
                    align="center"
                    style={{ textAlign: "center" }}
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <ThreeDots
                        color={userDetails.implementation_color}
                        height={80}
                        width={80}
                        ariaLabel="loading"
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                filteredAndSortedSections.map((section) => (
                  <TableRow key={section.id}>
                    <TableCell>{section.section_name}</TableCell>
                    <TableCell>{section.start_date}</TableCell>
                    <TableCell>{section.end_date}</TableCell>
                    <TableCell>
                      <span
                        style={{
                          display: "inline-block",
                          width: "14px",
                          height: "14px",
                          borderRadius: "50%",
                          backgroundColor: getStatusCircleColor(section.status),
                          marginRight: "8px",
                        }}
                      />
                      {section.status}
                    </TableCell>
                    <TableCell style={{ textAlign: "middle" }}>
                      <Tippy
                        appendTo={appendTippyToBody}
                        content={
                          <PerfectScrollbar
                            style={{ maxHeight: 400, padding: "0 8px" }}
                            options={{ suppressScrollX: true }}
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                __html: section.keyMessage,
                              }}
                            />
                          </PerfectScrollbar>
                        }
                        animation="scale"
                        maxWidth="400px"
                        theme="light"
                        interactive={true}
                        arrow={true}
                      >
                        <div className={classes.actionIconsCustom}>
                          <Comment className={classes.iconButtonCustom} />
                        </div>
                      </Tippy>
                    </TableCell>

                    {/* SWAPPED COLUMN: NEXT STEPS goes here */}
                    {userDetails?.has_next_steps && (
                      <TableCell style={{ textAlign: "middle" }}>
                        <Tippy
                          appendTo={appendTippyToBody}
                          content={
                            <PerfectScrollbar
                              style={{ maxHeight: 400, padding: "0 8px" }}
                              options={{ suppressScrollX: true }}
                            >
                              <div
                                // FIX: Use section.next_steps (the correct field name)
                                dangerouslySetInnerHTML={{
                                  __html: section.next_steps,
                                }}
                              />
                            </PerfectScrollbar>
                          }
                          animation="scale"
                          maxWidth="400px"
                          theme="light"
                          interactive={true}
                          arrow={true}
                        >
                          <div className={classes.actionIconsCustom}>
                            <FontAwesomeIcon
                              icon={faForward} // Icon representing "Next Steps"
                              className={classes.iconButtonCustom}
                              style={{ fontSize: "20px" }}
                            />
                          </div>
                        </Tippy>
                      </TableCell>
                    )}

             
                    {userDetails?.has_decisions_needed && (
                      <TableCell style={{ textAlign: "center" }}>
                        <Tippy
                        appendTo={appendTippyToBody}
                          content={
                            <PerfectScrollbar
                            style={{ maxHeight: 300, padding: '0 8px' }}
                            options={{ suppressScrollX: true }}
                          >
                            <div style={{ maxWidth: "300px" }}>
                              {decisions
                                .filter((dec) => dec.section_id === section.id)
                                .map((decItem) => {
                                const thisInitiative = initiatives.find(
                                  (i) => i.id === decItem.initiative_id
                                );
                                return (
                                  <div
                                    key={decItem.id}
                                    style={{
                                      marginBottom: "8px",
                                      borderBottom: "1px solid #ccc",
                                      paddingBottom: "8px",
                                    }}
                                  >
                                    <div style={{ marginBottom: "6px" }}>
                                      {getPriorityChip(decItem.priority)}
                                    </div>
                                    <strong>{decItem.decisionTitle}</strong>
                                    <br />
                                    <em style={{ fontSize: "0.8em" }}>
                                      {thisInitiative
                                        ? `${t("control_panel.decisions.initiative_label")} ${
                                            thisInitiative.initiative
                                          }`
                                        : `${t("control_panel.decisions.program_related")}`}
                                    </em>
                                    <p style={{ margin: "4px 0" }}>
                                      {decItem.decisionDescription}
                                    </p>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={decItem.done || false}
                                          onChange={(e) =>
                                            handleDecisionToggle(
                                              decItem.id,
                                              e.target.checked
                                            )
                                          }
                                          icon={
                                            <RadioButtonUnchecked
                                              style={{ color: "#aaa" }}
                                            />
                                          }
                                          checkedIcon={
                                            <CheckCircle
                                              style={{ color: clientColor }}
                                            />
                                          }
                                        />
                                      }
                                      label={
                                        decItem.done
                                          ? t(
                                              "control_panel.decisions.decision_defined"
                                            )
                                          : t(
                                              "control_panel.decisions.mark_as_defined"
                                            )
                                      }
                                      style={{ marginTop: "0px" }}
                                    />
                                  </div>
                                );
                              })}
                            {decisions.filter(
                              (dec) => dec.section_id === section.id
                            ).length === 0 && (
                              <p style={{ color: "#999" }}>
                                {t(
                                  "control_panel.sections.no_decisions_needed"
                                )}
                              </p>
                            )}
                          </div>
                          </PerfectScrollbar>
                        }
                        animation="scale"
                        theme="light"
                        interactive={true}
                        arrow={true}
                      >
                          <div className={classes.actionIconsCustom}>
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              className={classes.iconButtonCustom}
                              style={{ fontSize: "20px" }}
                            />
                          </div>
                        </Tippy>
                      </TableCell>
                    )}

                    <TableCell>
                      <div className={classes.actionIconsCustom}>
                        {new Date(section.end_date) < new Date() ? (
                          <Tooltip
                            title={t(
                              "control_panel.sections.edit_past_disabled",
                              "Edição desabilitada após data final"
                            )}
                            arrow
                          >
                            <EditIcon
                              className={classes.iconButtonCustom}
                              style={{ opacity: 0.5, cursor: "not-allowed" }}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title={t("control_panel.common.edit")} arrow>
                            <EditIcon
                              className={classes.iconButtonCustom}
                              onClick={() => handleEditSection(section)}
                            />
                          </Tooltip>
                        )}
                        {new Date(section.end_date) < new Date() ? (
                          <Tooltip
                            title={t(
                              "control_panel.sections.delete_past_disabled",
                              "Não é possível excluir seção após a data final"
                            )}
                            arrow
                          >
                            <DeleteIcon
                              className={classes.iconButtonCustom}
                              style={{ opacity: 0.5, cursor: "not-allowed" }}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip
                            title={t("control_panel.common.delete")}
                            arrow
                          >
                            <DeleteIcon
                              className={classes.iconButtonCustom}
                              onClick={() =>
                                handleOpenDeleteDialog({
                                  type: "section",
                                  id: section.id,
                                  name: section.section_name,
                                })
                              }
                            />
                          </Tooltip>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>

      {/* Accordion 2 -Initiatives
      <Accordion className={classes.accordionRootCustom}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <CardHeader
            color="client"
            icon
            style={{ marginTop: "10px", display: "flex", alignItems: "center" }}
          >
            <CardIcon color="client">
              <Assessment />
            </CardIcon>
            <h4
              className={classes.cardIconTitle}
              style={{ marginBottom: 0, whiteSpace: "nowrap" }}
            >
              {t("control_panel.initiatives.title")}
            </h4>
          </CardHeader>
        </AccordionSummary>
        <AccordionDetails style={{ display: "block" }}>
          {/* Filters (Branch, Workfront, and Initiative)
          <GridContainer justifyContent="flex">
            <GridItem className={classes.filterItem} xs={12} sm={8}>
              <Box display="flex" alignItems="center">
                <FontAwesomeIcon
                  icon={faFilter}
                  style={{
                    marginRight: "8px",
                    fontSize: "20px",
                    color: "#666",
                  }}
                />
                {/* Branch 
                <FormControl
                  size="medium"
                  className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                  style={{ marginRight: "16px" }}
                >
                  <Select
                    displayEmpty
                    value={branchFilter}
                    onChange={(e) => setBranchFilter(e.target.value)}
                    classes={{
                      select: `${classes.select} ${classes.selectFormControlOverride}`,
                    }}
                  >
                    <MenuItem value="">
                      {t("control_panel.initiatives.filters.all_branches")}
                    </MenuItem>
                    {uniqueBranches.map((branchName) => (
                      <MenuItem key={branchName} value={branchName}>
                        {branchName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box mx={1} />

                {/* Workfront Filter
                <FormControl
                  size="medium"
                  className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                  style={{ marginRight: "16px" }}
                >
                  <Select
                    displayEmpty
                    value={workfrontFilter}
                    onChange={(e) => setWorkfrontFilter(e.target.value)}
                    classes={{
                      select: `${classes.select} ${classes.selectFormControlOverride}`,
                    }}
                  >
                    <MenuItem value="">
                      {t("control_panel.initiatives.filters.all_workfronts")}
                    </MenuItem>
                    {uniqueWorkfronts.map((wf) => (
                      <MenuItem key={wf} value={wf}>
                        {wf}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box mx={1} />

                {/* Initiative Filter (Text)
                <div style={{ padding: "0px 0px 15px 0px" }}>
                  <TextField
                    label={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0px",
                        }}
                      >
                        {t(
                          "control_panel.initiatives.filters.filter_initiatives"
                        )}
                        <SearchIcon className={classes.searchIcon} />
                      </div>
                    }
                    value={initiativeFilter}
                    onChange={(e) => setInitiativeFilter(e.target.value)}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{
                      classes: { input: classes.inputText },
                      style: { fontSize: "12px", width: "250px" },
                    }}
                    InputLabelProps={{
                      classes: { root: classes.labelText },
                      shrink: true,
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
              </Box>
            </GridItem>
          </GridContainer>

          {/* Main initiative table
          <Table>
            <TableHead>
              <TableRow>
                {/* Example of columns with sound icons 
                <TableCell
                  className={classes.tableHeadCell}
                  onClick={() => handleSortInitiatives("branch")}
                  style={{ cursor: "pointer" }}
                >
                  <div className={classes.tableHeaderIcon}>
                    {t("control_panel.initiatives.table.headers.branch")}
                    <FontAwesomeIcon
                      icon={
                        sortConfigInitiatives.key === "branch"
                          ? sortConfigInitiatives.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfigInitiatives.key === "branch"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>

                <TableCell
                  className={classes.tableHeadCell}
                  onClick={() => handleSortInitiatives("workfront")}
                  style={{ cursor: "pointer" }}
                >
                  <div className={classes.tableHeaderIcon}>
                    {t("control_panel.initiatives.table.headers.workfront")}
                    <FontAwesomeIcon
                      icon={
                        sortConfigInitiatives.key === "workfront"
                          ? sortConfigInitiatives.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfigInitiatives.key === "workfront"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>

                <TableCell
                  className={classes.tableHeadCell}
                  onClick={() => handleSortInitiatives("initiative")}
                  style={{ cursor: "pointer" }}
                >
                  <div className={classes.tableHeaderIcon}>
                    {t("control_panel.initiatives.table.headers.initiative")}
                    <FontAwesomeIcon
                      icon={
                        sortConfigInitiatives.key === "initiative"
                          ? sortConfigInitiatives.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfigInitiatives.key === "initiative"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>

                {/* Other existing columns
                <TableCell className={classes.tableHeadCell}>
                  {t("control_panel.initiatives.table.headers.approval_gates")}
                </TableCell>
                <TableCell className={classes.tableHeadCell}>
                  {t("control_panel.initiatives.table.headers.last_onepage")}
                </TableCell>
                <TableCell className={classes.tableHeadCell}>
                  {t(
                    "control_panel.initiatives.table.headers.last_implementation"
                  )}
                </TableCell>
                <TableCell className={classes.tableHeadCell}>
                  {t("control_panel.initiatives.table.headers.last_planned")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortData(
                initiatives
                  .filter((init) =>
                    branchFilter ? init.branch === branchFilter : true
                  )
                  .filter((init) =>
                    workfrontFilter ? init.workfront === workfrontFilter : true
                  )
                  .filter((init) =>
                    initiativeFilter
                      ? init.initiative
                          ?.toLowerCase()
                          .includes(initiativeFilter.toLowerCase())
                      : true
                  ),
                sortConfigInitiatives
              ).map((init) => (
                <TableRow key={init.id}>
                  <TableCell>{init.branch}</TableCell>
                  <TableCell>{init.workfront}</TableCell>
                  <TableCell>{init.initiative}</TableCell>
                  <TableCell>
                    {init.approvalGates.map((g, idx) => (
                      <div key={idx}>
                        <strong>{g.gateName}:</strong>{" "}
                        <span style={{ color: g.approved ? "green" : "red" }}>
                          {g.approved
                            ? t("control_panel.initiatives.labels.approved")
                            : t("control_panel.initiatives.labels.pending")}
                        </span>{" "}
                        ({g.approvers.join(", ")})
                      </div>
                    ))}
                  </TableCell>
                  <TableCell>{init.lastOnePageUpdate}</TableCell>
                  <TableCell>{init.lastImplementationPlanUpdate}</TableCell>
                  <TableCell>{init.lastPlannedResultsUpdate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>

      */}

      {/* Accordion 3 -Global Variables 
      <Accordion className={classes.accordionRootCustom}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <CardHeader
            color="client"
            icon
            style={{ marginTop: "10px", display: "flex", alignItems: "center" }}
          >
            <CardIcon color="client">
              <Functions />
            </CardIcon>
            <h4
              className={classes.cardIconTitle}
              style={{ marginBottom: 0, whiteSpace: "nowrap" }}
            >
              {t("control_panel.global_vars.title")}
            </h4>
          </CardHeader>
        </AccordionSummary>
        <AccordionDetails style={{ display: "block" }}>
          <ExchangeRates />
        </AccordionDetails>
      </Accordion>*/}
      {console.log(editingSectionId)}
      {/* DRAWER - Sections */}
      <Drawer
        anchor="right"
        open={messageDrawerOpen}
        onClose={() => {
          // Se estiver em modo de edição (seção existente) e existirem alterações não salvas
          if (editingSectionId !== null && hasUnsavedSectionChanges) {
            // Callback para Discard: descarta alterações e fecha o drawer
            setOnDiscardConfirm(() => () => {
              handleCloseSectionDrawer();
              setHasUnsavedSectionChanges(false);
            });
            // Callback para Cancel: não faz nada (apenas fecha o dialog)
            setOnDiscardCancel(() => () => {
              /* In Action */
            });
            setUnsavedDialogOpen(true);
          } else {
            // Caso contrário, fecha o drawer diretamente
            handleCloseSectionDrawer();
          }
        }}
        BackdropProps={{
          style: { backgroundColor: "#000", opacity: "0.1" },
        }}
        PaperProps={{
          style: {
            borderRadius: "10px",
            margin: "1vh 1vh 1vh 0",
            height: "98vh",
            width: "800px",
          },
        }}
      >
        <div
          className={classes.drawer}
          style={{
            width: "100%",
            padding: "16px",
            position: "relative", // Necessário para posicionamento absoluto do spinner
          }}
        >
          {isLoading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <ThreeDots
                color={userDetails.implementation_color}
                height={80}
                width={80}
                ariaLabel="loading"
              />
            </div>
          ) : (
            <>
              <Typography variant="h6" gutterBottom>
                {editingSectionId
                  ? t("control_panel.sections.drawer.edit_title")
                  : t("control_panel.sections.drawer.title")}
              </Typography>
              <form noValidate autoComplete="off">
                <Grid container spacing={3} style={{ width: "100%" }}>
                  {/* Resto do conteúdo original do formulário */}
                  <Grid item xs={12}>
                    <TextField
                      label={t("control_panel.sections.form.section_name")}
                      name="section_name"
                      value={newSection.section_name}
                      onChange={(e) => {
                        setNewSection({
                          ...newSection,
                          section_name: e.target.value,
                        });
                        if (editingSectionId !== null) {
                          setHasUnsavedSectionChanges(true);
                        }
                      }}
                      fullWidth
                      multiline
                      rows={1}
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{ classes: { root: classes.labelText } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={t("control_panel.sections.form.start_date")}
                      name="start_date"
                      type="date"
                      value={newSection.start_date}
                      onChange={(e) =>
                        setNewSection({
                          ...newSection,
                          start_date: e.target.value,
                        })
                      }
                      fullWidth
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={t("control_panel.sections.form.end_date")}
                      name="end_date"
                      type="date"
                      value={newSection.end_date}
                      onChange={(e) =>
                        setNewSection({
                          ...newSection,
                          end_date: e.target.value,
                        })
                      }
                      fullWidth
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                        shrink: true,
                      }}
                      // ← novas props abaixo
                      error={isInvalidDate}
                      helperText={
                        isInvalidDate
                          ? t(
                              "control_panel.sections.form.error_invalid_date",
                              "Data de término não pode ser anterior à data de início."
                            )
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <TextField
                        select
                        label={t("control_panel.sections.form.status")}
                        name="status"
                        value={newSection.status}
                        onChange={(e) =>
                          setNewSection({
                            ...newSection,
                            status: e.target.value,
                          })
                        }
                        classes={{ root: classes.textFieldRoot }}
                        InputProps={{ classes: { input: classes.inputText } }}
                        InputLabelProps={{
                          classes: { root: classes.labelText },
                        }}
                      >
                        <MenuItem value="Green">
                          {t("control_panel.sections.status.green")}
                        </MenuItem>
                        <MenuItem value="Yellow">
                          {t("control_panel.sections.status.yellow")}
                        </MenuItem>
                        <MenuItem value="Red">
                          {t("control_panel.sections.status.red")}
                        </MenuItem>
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <div className={classes.textEditorRoot}>
                      <Typography
                        variant="subtitle1"
                        className={classes.textEditorTitle}
                        style={{
                          marginBottom: "8px", // Adds space below

                          color: "#666", // Defines the personalized color

                          display: "flex", // To align the icon next to the text

                          alignItems: "center",
                        }}
                      >
                        {t("control_panel.sections.form.key_message")}
                        <Tooltip
                          title={t(
                            "control_panel.sections.form.key_message_tooltip"
                          )}
                          arrow
                        >
                          <Info
                            style={{
                              fontSize: "18px", // Icon size

                              marginLeft: "8px", // Spacing between text and icon

                              color: "#666", // Same text color

                              cursor: "pointer", // Shows that it is interactive
                            }}
                          />
                        </Tooltip>
                                                 {/* AI Button - Right-aligned */}
                                                 <Box ml="auto" display="flex" alignItems="center">
                          <Box position="relative">
                            {/* AI Loading Messages - Positioned to the left of the button */}
                            <AiLoadingMessage 
                              isLoading={isAiGenerating} 
                              interval={2500}
                            />
                            
                            <Tooltip
                              title={t(
                                "control_panel.sections.form.ai_generate_key_message",
                                "Gerar Key Messages automaticamente com IA"
                              )}
                              arrow
                            >
                              <Button
                                color="client"
                                className={classes.cardButton}
                                onClick={handleGenerateKeyMessage}
                                disabled={isAiGenerating}
                                size="sm"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "8px",
                                }}
                              >
                                                                {isAiGenerating ? (
                                   <ThreeDots
                                     color="#ffffff"
                                     height={18}
                                     width={18}
                                     ariaLabel="generating"
                                     style={{
                                       position: "absolute",
                                       top: "50%",
                                       left: "50%",
                                       transform: "translate(-50%, -50%)",
                                     }}
                                   />
                                 ) : (
                                   <FontAwesomeIcon
                                     icon={faRobot}
                                     style={{
                                       fontSize: "18px",
                                       color: "#ffffff",
                                       position: "absolute",
                                       top: "50%",
                                       left: "50%",
                                       transform: "translate(-50%, -50%)",
                                     }}
                                   />
                                 )}
                              </Button>
                            </Tooltip>
                          </Box>
                        </Box>
                      </Typography>
                      <TextEditor
                        initialContent={newSection.keyMessage}
                        setContent={(html) => {
                          setNewSection({ ...newSection, keyMessage: html });
                          if (editingSectionId !== null) {
                            setHasUnsavedSectionChanges(true);
                          }
                        }}
                        readOnly={false}
                      />
                    </div>
                  </Grid>
                  {/* Next Steps - Conditional based on implementation flag */}
                  {userDetails?.has_next_steps && (
                    <Grid item xs={12}>
                      <div className={classes.textEditorRoot}>
                        <Typography
                          variant="subtitle1"
                          className={classes.textEditorTitle}
                          style={{
                            marginBottom: "8px",
                            color: "#666",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {t("control_panel.sections.form.next_steps")}
                          <Tooltip
                            title={t(
                              "control_panel.sections.form.next_steps_tooltip"
                            )}
                            arrow
                          >
                            <Info
                              style={{
                                fontSize: "18px",
                                marginLeft: "8px",
                                color: "#666",
                                cursor: "pointer",
                              }}
                            />
                          </Tooltip>
                        </Typography>
                        <TextEditor
                          initialContent={newSection.next_steps}
                          setContent={(html) => {
                            setNewSection({ ...newSection, next_steps: html });
                            if (editingSectionId !== null) {
                              setHasUnsavedSectionChanges(true);
                            }
                          }}
                          readOnly={false}
                        />
                      </div>
                    </Grid>
                  )}
                  {/* Decisions Needed - Conditional based on implementation flag */}
                  {userDetails?.has_decisions_needed && (
                    <Grid item xs={12}>
                    <Accordion className={classes.accordionRootHighlights}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle1">
                          {t(
                            "control_panel.sections.drawer.decisions_needed_title"
                          )}
                        </Typography>
                      </AccordionSummary>
                        <AccordionDetails
                          style={{ display: "block", width: "100%" }}
                        >
                          {/* FORM FOR NEW DECISION */}
                          <Box
                            mb={2}
                            p={2}
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                            }}
                          >
                            <Typography
                              variant="body1"
                              style={{ marginBottom: "8px" }}
                            >
                              {t(
                                "control_panel.sections.drawer.add_decision_needed"
                              )}
                            </Typography>
                            <Grid item xs={12}>
                              <FormControlLabel
                                style={{ marginBottom: "16px" }} // Added bottom margin
                                control={
                                  <Checkbox
                                    checked={isProgramRelated}
                                    onChange={(e) => {
                                      setIsProgramRelated(e.target.checked);
                                      if (e.target.checked) {
                                        // Se marcado, limpa o valor da iniciativa
                                        setNewDecision({
                                          ...newDecision,
                                          initiative_id: "",
                                        });
                                      }
                                    }}
                                    icon={
                                      <RadioButtonUnchecked
                                        style={{ color: "#aaa" }}
                                      />
                                    }
                                    checkedIcon={
                                      <CheckCircle
                                        style={{
                                          color: clientColor,
                                        }}
                                      />
                                    }
                                  />
                                }
                                label={t(
                                  "control_panel.decisions.program_related"
                                )}
                              />
                            </Grid>

                            <Grid container spacing={2}>
                              {/* Select Initiative or Program */}
                              <Grid item xs={12} sm={6}>
                                <Autocomplete
                                  options={initiatives}
                                  getOptionLabel={(option) => option.name}
                                  onChange={(event, value) => {
                                    setNewDecision({
                                      ...newDecision,
                                      initiative_id: value ? value.id : "",
                                    });
                                  }}
                                  // Se "Program Related" estiver marcado, força o valor do autocomplete a ser null
                                  value={
                                    isProgramRelated
                                      ? null
                                      : initiatives.find(
                                          (option) =>
                                            option.id ===
                                            newDecision.initiative_id
                                        ) || null
                                  }
                                  disabled={isProgramRelated}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={t(
                                        "control_panel.sections.drawer.decision_form.initiative_optional"
                                      )}
                                      variant="outlined"
                                      fullWidth
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                        shrink: true,
                                      }}
                                      InputProps={{
                                        ...params.InputProps,
                                        classes: {
                                          notchedOutline:
                                            classes.customOutlined,
                                        },
                                      }}
                                      classes={{ root: classes.textFieldRoot }}
                                    />
                                  )}
                                />
                              </Grid>

                              {/* Priority */}
                              <Grid item xs={12} sm={6}>
                                <FormControl
                                  fullWidth
                                  className={classes.selectFormControl}
                                >
                                  <TextField
                                    select
                                    label={t(
                                      "control_panel.sections.drawer.decision_form.priority"
                                    )}
                                    value={newDecision.priority || ""}
                                    onChange={(e) =>
                                      setNewDecision({
                                        ...newDecision,
                                        priority: e.target.value,
                                      })
                                    }
                                    classes={{ root: classes.textFieldRoot }}
                                    InputProps={{
                                      classes: { input: classes.inputText },
                                    }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                  >
                                    <MenuItem value="High">
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        {getPriorityChip("High")}
                                      </div>
                                    </MenuItem>
                                    <MenuItem value="Medium">
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        {getPriorityChip("Medium")}
                                      </div>
                                    </MenuItem>
                                    <MenuItem value="Low">
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        {getPriorityChip("Low")}
                                      </div>
                                    </MenuItem>
                                  </TextField>
                                </FormControl>
                              </Grid>

                              {/* Decision Title */}
                              <Grid item xs={12}>
                                <TextField
                                  label={t(
                                    "control_panel.sections.drawer.decision_form.decision_title"
                                  )}
                                  value={newDecision.decisionTitle || ""}
                                  onChange={(e) =>
                                    setNewDecision({
                                      ...newDecision,
                                      decisionTitle: e.target.value,
                                    })
                                  }
                                  fullWidth
                                  classes={{ root: classes.textFieldRoot }}
                                  InputProps={{
                                    classes: { input: classes.inputText },
                                  }}
                                  InputLabelProps={{
                                    classes: { root: classes.labelText },
                                  }}
                                />
                              </Grid>

                              {/* Decision Description */}
                              <Grid item xs={12}>
                                <TextField
                                  label={t(
                                    "control_panel.sections.drawer.decision_form.decision_description"
                                  )}
                                  value={newDecision.decisionDescription || ""}
                                  onChange={(e) =>
                                    setNewDecision({
                                      ...newDecision,
                                      decisionDescription: e.target.value,
                                    })
                                  }
                                  fullWidth
                                  multiline
                                  rows={3}
                                  classes={{ root: classes.textFieldRoot }}
                                  InputProps={{
                                    classes: { input: classes.inputText },
                                  }}
                                  InputLabelProps={{
                                    classes: { root: classes.labelText },
                                  }}
                                />
                              </Grid>

                              {/* Save button */}
                              <Grid item xs={12}>
                                <Button
                                  justIcon
                                  color="client"
                                  className={classes.cardButton}
                                  onClick={async () => {
                                    if (
                                      !newDecision.decisionTitle ||
                                      !newDecision.priority
                                    ) {
                                      notify(t("control_panel.decisions.required_fields", "Preencha título e prioridade"), "warning");
                                      return;
                                    }

                                    // Validação: se não for Program Related, initiative_id deve estar preenchido
                                    if (
                                      !isProgramRelated &&
                                      !newDecision.initiative_id
                                    ) {
                                      notify(
                                        t("control_panel.decisions.select_initiative", "Selecione uma iniciativa ou marque como relacionada ao programa"),
                                        "warning"
                                      );
                                      return;
                                    }

                                    if (editingDecisionId) {
                                      // Check if it's a pending decision (CREATE mode)
                                      const isPendingEdit = editingSectionId === null;
                                      
                                      if (isPendingEdit) {
                                        // Update pending decision in local state
                                        setPendingDecisions(
                                          pendingDecisions.map(pd => 
                                            pd.id === editingDecisionId 
                                              ? {
                                                  ...pd,
                                                  initiative_id: isProgramRelated ? "" : newDecision.initiative_id,
                                                  is_program_related: isProgramRelated,
                                                  priority: newDecision.priority,
                                                  decisionTitle: newDecision.decisionTitle,
                                                  decisionDescription: newDecision.decisionDescription,
                                                }
                                              : pd
                                          )
                                        );
                                        notify(t("control_panel.decisions.updated_success", "Decisão atualizada!"), "success");
                                      } else {
                                        // EDIÇÃO DE DECISION EXISTENTE (via API)
                                        try {
                                          const payload = {
                                            action: "updateDecision",
                                            id: editingDecisionId,
                                            section_id: editingSectionId || "",
                                            initiative_id: isProgramRelated
                                              ? ""
                                              : newDecision.initiative_id || "",
                                            is_program_related: isProgramRelated,
                                            priority: newDecision.priority,
                                            decisionTitle:
                                              newDecision.decisionTitle,
                                            decisionDescription:
                                              newDecision.decisionDescription,
                                          };

                                          const response = await client.post(
                                            "/api/control-panel-sections-decisions/",
                                            payload
                                          );

                                          if (response.status !== 200) {
                                            throw new Error(
                                              "Failed to update decision"
                                            );
                                          }
                                          const data = response.data;
                                          if (data.success) {
                                            await refreshSectionsAndDecisions();
                                            notify(t("control_panel.decisions.updated_success", "Decisão atualizada!"), "success");
                                          } else {
                                            console.error(
                                              "API error:",
                                              data.error
                                            );
                                          }
                                        } catch (error) {
                                          console.error(
                                            "Error updating decision:",
                                            error
                                          );
                                          notify(t("control_panel.decisions.update_error", "Erro ao atualizar decisão"), "error");
                                        }
                                      }

                                      setEditingDecisionId(null);
                                      setNewDecision({
                                        initiative_id: "",
                                        priority: "",
                                        decisionTitle: "",
                                        decisionDescription: "",
                                      });
                                      setIsProgramRelated(false);
                                    } else if (editingSectionId !== null) {
                                      // CRIAÇÃO DE DECISION EM SECTION EXISTENTE
                                      try {
                                        const payload = {
                                          action: "createDecision",
                                          section_id: editingSectionId,
                                          initiative_id: isProgramRelated
                                            ? ""
                                            : newDecision.initiative_id || "",
                                          is_program_related: isProgramRelated,
                                          priority: newDecision.priority,
                                          decisionTitle:
                                            newDecision.decisionTitle,
                                          decisionDescription:
                                            newDecision.decisionDescription,
                                          done: false,
                                        };

                                        const response = await client.post(
                                          "/api/control-panel-sections-decisions/",
                                          payload
                                        );

                                        if (response.status !== 200) {
                                          throw new Error(
                                            "Failed to create decision"
                                          );
                                        }
                                        const data = response.data;
                                        if (data.success) {
                                          await refreshSectionsAndDecisions();
                                          notify(t("control_panel.decisions.created_success", "Decisão criada!"), "success");
                                        } else {
                                          console.error(
                                            "API error:",
                                            data.error
                                          );
                                        }
                                      } catch (error) {
                                        console.error(
                                          "Error creating decision:",
                                          error
                                        );
                                        notify(t("control_panel.decisions.create_error", "Erro ao criar decisão"), "error");
                                      }
                                    } else {
                                      // MODO CREATE: Adiciona à lista de pending decisions
                                      const newPendingDecision = {
                                        id: Date.now(), // ID temporário
                                        initiative_id: isProgramRelated ? "" : newDecision.initiative_id,
                                        is_program_related: isProgramRelated,
                                        priority: newDecision.priority,
                                        decisionTitle: newDecision.decisionTitle,
                                        decisionDescription: newDecision.decisionDescription,
                                        done: false,
                                      };
                                      
                                      setPendingDecisions([...pendingDecisions, newPendingDecision]);
                                      notify(
                                        t("control_panel.decisions.added", "Decisão adicionada!"), 
                                        "success"
                                      );
                                    }

                                    // Limpa o formulário
                                    setNewDecision({
                                      initiative_id: "",
                                      priority: "",
                                      decisionTitle: "",
                                      decisionDescription: "",
                                    });
                                    setIsProgramRelated(false);
                                  }}
                                >
                                  <Save className={classes.cardButtonIcon} />
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>

                          {/* LIST OF DECISIONS */}
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  {t(
                                    "control_panel.sections.drawer.decision_table.initiative"
                                  )}
                                </TableCell>
                                <TableCell>
                                  {t(
                                    "control_panel.sections.drawer.decision_table.priority"
                                  )}
                                </TableCell>
                                <TableCell>
                                  {t(
                                    "control_panel.sections.drawer.decision_table.title"
                                  )}
                                </TableCell>
                                <TableCell>
                                  {t(
                                    "control_panel.sections.drawer.decision_table.description"
                                  )}
                                </TableCell>
                                {/* New column */}
                                <TableCell>
                                  {t(
                                    "control_panel.sections.drawer.decision_table.done"
                                  )}
                                </TableCell>
                                <TableCell align="center">
                                  {t(
                                    "control_panel.sections.drawer.decision_table.actions"
                                  )}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* Show pending decisions in CREATE mode, real decisions in EDIT mode */}
                              {(editingSectionId === null ? pendingDecisions : decisions.filter(d => d.section_id === editingSectionId))
                                .map((d) => {
                                  const thisInitiative = initiatives.find(
                                    (i) => i.id === d.initiative_id
                                  );
                                  const isPending = editingSectionId === null;

                                  return (
                                    <TableRow key={d.id}>
                                      <TableCell>
                                        {thisInitiative
                                          ? thisInitiative.name
                                          : t(
                                              "control_panel.decisions.program_related"
                                            )}
                                      </TableCell>
                                      <TableCell>
                                        {getPriorityChip(d.priority)}
                                      </TableCell>
                                      <TableCell>{d.decisionTitle}</TableCell>
                                      <TableCell>
                                        {d.decisionDescription}
                                      </TableCell>

                                      {/* Done column - disabled for pending decisions */}
                                      <TableCell>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={d.done || false}
                                              onChange={(e) =>
                                                handleDecisionToggle(
                                                  d.id,
                                                  e.target.checked
                                                )
                                              }
                                              disabled={isPending}
                                              icon={
                                                <RadioButtonUnchecked
                                                  style={{ color: "#aaa" }}
                                                />
                                              }
                                              checkedIcon={
                                                <CheckCircle
                                                  style={{ color: clientColor }}
                                                />
                                              }
                                            />
                                          }
                                          label=""
                                          style={{ marginTop: "0px" }}
                                        />
                                      </TableCell>

                                      <TableCell align="center">
                                        <Tooltip
                                          title={t(
                                            "control_panel.sections.drawer.decision_form.edit_decision"
                                          )}
                                          arrow
                                        >
                                          <IconButton
                                            size="small"
                                            onClick={() => {
                                              if (isPending) {
                                                // Edit pending decision
                                                setEditingDecisionId(d.id);
                                                setNewDecision({
                                                  initiative_id: d.initiative_id,
                                                  priority: d.priority,
                                                  decisionTitle: d.decisionTitle,
                                                  decisionDescription: d.decisionDescription,
                                                });
                                                setIsProgramRelated(d.is_program_related || false);
                                              } else {
                                                // Edit real decision
                                                setEditingDecisionId(d.id);
                                                setNewDecision({
                                                  initiative_id: d.initiative_id,
                                                  priority: d.priority,
                                                  decisionTitle: d.decisionTitle,
                                                  decisionDescription: d.decisionDescription,
                                                });
                                                setIsProgramRelated(d.is_program_related || false);
                                              }
                                            }}
                                          >
                                            <EditIcon
                                              className={
                                                classes.iconButtonCustom
                                              }
                                            />
                                          </IconButton>
                                        </Tooltip>
                                        <Tooltip
                                          title={t(
                                            "control_panel.sections.drawer.decision_form.delete_decision"
                                          )}
                                          arrow
                                        >
                                          <IconButton
                                            size="small"
                                            onClick={() => {
                                              if (isPending) {
                                                // Remove from pending list
                                                setPendingDecisions(pendingDecisions.filter(pd => pd.id !== d.id));
                                              } else {
                                                // Delete real decision via dialog
                                                handleOpenDeleteDialog({
                                                  type: "decision",
                                                  id: d.id,
                                                  name: d.decisionTitle,
                                                });
                                              }
                                            }}
                                          >
                                            <DeleteIcon
                                              className={
                                                classes.iconButtonCustom
                                              }
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                            </TableBody>
                          </Table>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <GridItem
                      style={{
                        zIndex: 1000,
                        position: "absolute",
                        right: "15px",
                        top: "10px",
                      }}
                    >
                      <Button
                        justIcon
                        color="client"
                        className={classes.cardButton}
                        onClick={handleSaveSection}
                        disabled={isInvalidDate}
                      >
                        <Save className={classes.cardButtonIcon} />
                      </Button>
                    </GridItem>
                  </Grid>
                </Grid>
              </form>
            </>
          )}
        </div>
      </Drawer>
      {/* Unsaved Changes Confirmation Dialog */}
      <Dialog
        open={unsavedDialogOpen}
        onClose={() => {
          setUnsavedDialogOpen(false);
          // Simply close the dialog; do not save any changes here.
        }}
        aria-labelledby="discard-changes-dialog-title"
        aria-describedby="discard-changes-dialog-description"
      >
        <DialogTitle id="discard-changes-dialog-title">
          {t("control_panel.unsaved_changes.dialog.title")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="discard-changes-dialog-description">
            {t("control_panel.unsaved_changes.dialog.description")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              // Cancel: just close the dialog, keeping the drawer open

              setUnsavedDialogOpen(false);
            }}
            color="client"
          >
            {t("control_panel.unsaved_changes.dialog.cancel")}
          </Button>
          <Button
            onClick={() => {
              // Discard: trigger the discard callback (closes drawer and discards changes)

              setUnsavedDialogOpen(false);
              if (onDiscardConfirm) onDiscardConfirm();
            }}
            color="secondary"
            autoFocus
          >
            {t("control_panel.unsaved_changes.dialog.discard")}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Exclusion Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="delete-confirmation-dialog-title"
        aria-describedby="delete-confirmation-dialog-description"
      >
        <DialogTitle id="delete-confirmation-dialog-title">
          {t("control_panel.delete_confirmation.title")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-confirmation-dialog-description">
            {t("control_panel.delete_confirmation.text")}{" "}
            <strong>{deleteTarget.name}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="client" size="small">
            {t("control_panel.delete_confirmation.cancel")}
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="secondary"
            autoFocus
            size="small"
          >
            {t("control_panel.delete_confirmation.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
